import React, { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useTenant } from '../../contexts/TenantContext'
import { getModulesForTenant } from '../../config/modulesByTenant'
import UserContext from '../../contexts/UserContext'

interface TenantGuardProps {
  children: React.ReactNode
  requiredTenant?: 'Aco' | 'fashion' | ('Aco' | 'fashion')[]
  requiredPath?: string
}

const TenantGuard: React.FC<TenantGuardProps> = ({ children, requiredTenant, requiredPath }) => {
  const { tenantId } = useTenant()
  const { token, user } = useContext(UserContext)
  const location = useLocation()

  console.log('🏢 [TENANT-GUARD] Snapshot', {
    pathname: location.pathname,
    requiredTenant,
    requiredPath,
    tenantId,
    hasToken: !!token,
    userId: user?.id || user?.sub,
    userRole: user?.role,
  })

  if (token && tenantId === null) {
    console.log('🏢 [TENANT-GUARD] Bloqueado temporariamente por tenantId nulo com token', {
      pathname: location.pathname,
    })
    return null
  }

  if (token && (!user || !user.id && !user.sub)) {
    console.log('🏢 [TENANT-GUARD] Bloqueado temporariamente por usuário ausente com token', {
      pathname: location.pathname,
    })
    return null
  }

  if (requiredTenant) {
    const hasAccess = () => {
      if (Array.isArray(requiredTenant)) {
        return requiredTenant.some(tenant => {
          if (tenant === 'Aco') {
            return tenantId !== 2
          } else if (tenant === 'fashion') {
            return tenantId === 2
          }
          return false
        })
      }

      if (requiredTenant === 'Aco') {
        return tenantId !== 2
      } else if (requiredTenant === 'fashion') {
        return tenantId === 2
      }
      return false
    }

    if (!hasAccess()) {
      console.warn('🏢 [TENANT-GUARD] Acesso negado por tenant incompatível', {
        pathname: location.pathname,
        requiredTenant,
        tenantId,
      })
      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '16px'
        }}>
          <h3>Acesso Restrito</h3>
          <p>Você não tem permissão para acessar este módulo.</p>
          <p>Este módulo é específico para tenant: {Array.isArray(requiredTenant) ? requiredTenant.join(', ') : requiredTenant}</p>
        </div>
      )
    }

    console.log('🏢 [TENANT-GUARD] Acesso liberado por tenant', {
      pathname: location.pathname,
      requiredTenant,
      tenantId,
    })

    return <>{children}</>
  }

  if (requiredPath) {
    const availableModules = getModulesForTenant(tenantId)
    const hasAccess = availableModules.some(module => module.path === requiredPath)

    console.log('🏢 [TENANT-GUARD] Verificação por requiredPath', {
      pathname: location.pathname,
      requiredPath,
      tenantId,
      availableModules: availableModules.map(module => module.path),
      hasAccess,
    })

    if (!hasAccess) {
      console.warn('🏢 [TENANT-GUARD] Redirecionando para home por requiredPath indisponível', {
        pathname: location.pathname,
        requiredPath,
        tenantId,
      })
      return <Navigate to="/panel" replace />
    }

    return <>{children}</>
  }

  return <>{children}</>
}

export default TenantGuard